
    /*
    * Auto Build of Registry
    */

    var registry = require("../uam/registry.js")("uat.elements");
    
        registry.add(require("../uat/src/animations/ua.a.conic.js"));
        registry.add(require("../uat/src/animations/ua.a.count.js"));
        registry.add(require("../uat/src/animations/ua.a.fade50.js"));
        registry.add(require("../uat/src/animations/ua.a.typeon.js"));
        registry.add(require("../uat/src/elements/chart.js.js"));
        registry.add(require("../uat/src/elements/checkout.preview.js"));
        registry.add(require("../uat/src/elements/email.button.js"));
        registry.add(require("../uat/src/elements/email.code.js"));
        registry.add(require("../uat/src/elements/email.footer.js"));
        registry.add(require("../uat/src/elements/email.greeting.js"));
        registry.add(require("../uat/src/elements/email.header.js"));
        registry.add(require("../uat/src/elements/email.role.list.js"));
        registry.add(require("../uat/src/elements/email.security.js"));
        registry.add(require("../uat/src/elements/email.text.js"));
        registry.add(require("../uat/src/elements/email.uajson.js"));
        registry.add(require("../uat/src/elements/home.flashshow.js"));
        registry.add(require("../uat/src/elements/lottie.dot.js"));
        registry.add(require("../uat/src/elements/pages.album.js"));
        registry.add(require("../uat/src/elements/pages.author.profile.js"));
        registry.add(require("../uat/src/elements/pages.blog.index.js"));
        registry.add(require("../uat/src/elements/pages.blog.js"));
        registry.add(require("../uat/src/elements/pages.blog.post.js"));
        registry.add(require("../uat/src/elements/pages.documentation.js"));
        registry.add(require("../uat/src/elements/pages.event.js"));
        registry.add(require("../uat/src/elements/pages.landing.js"));
        registry.add(require("../uat/src/elements/pages.meta.js"));
        registry.add(require("../uat/src/elements/pages.news.article.js"));
        registry.add(require("../uat/src/elements/pages.page.js"));
        registry.add(require("../uat/src/elements/pages.podcast.episode.js"));
        registry.add(require("../uat/src/elements/pages.podcast.js"));
        registry.add(require("../uat/src/elements/pages.preview.album.js"));
        registry.add(require("../uat/src/elements/pages.preview.author.profile.js"));
        registry.add(require("../uat/src/elements/pages.preview.blog.index.js"));
        registry.add(require("../uat/src/elements/pages.preview.blog.post.js"));
        registry.add(require("../uat/src/elements/pages.preview.documentation.js"));
        registry.add(require("../uat/src/elements/pages.preview.event.js"));
        registry.add(require("../uat/src/elements/pages.preview.js"));
        registry.add(require("../uat/src/elements/pages.preview.landing.js"));
        registry.add(require("../uat/src/elements/pages.preview.news.article.js"));
        registry.add(require("../uat/src/elements/pages.preview.podcast.episode.js"));
        registry.add(require("../uat/src/elements/pages.preview.podcast.js"));
        registry.add(require("../uat/src/elements/pages.preview.product.js"));
        registry.add(require("../uat/src/elements/pages.preview.recipe.js"));
        registry.add(require("../uat/src/elements/pages.preview.release.note.js"));
        registry.add(require("../uat/src/elements/pages.preview.song.js"));
        registry.add(require("../uat/src/elements/pages.preview.staff.profile.js"));
        registry.add(require("../uat/src/elements/pages.preview.standard.js"));
        registry.add(require("../uat/src/elements/pages.preview.video.js"));
        registry.add(require("../uat/src/elements/pages.preview.web.page.js"));
        registry.add(require("../uat/src/elements/pages.product.js"));
        registry.add(require("../uat/src/elements/pages.recipe.js"));
        registry.add(require("../uat/src/elements/pages.release.note.js"));
        registry.add(require("../uat/src/elements/pages.song.js"));
        registry.add(require("../uat/src/elements/pages.staff.profile.js"));
        registry.add(require("../uat/src/elements/pages.standard.js"));
        registry.add(require("../uat/src/elements/pages.video.js"));
        registry.add(require("../uat/src/elements/pages.web.page.js"));
        registry.add(require("../uat/src/elements/special.body.js"));
        registry.add(require("../uat/src/elements/ua.a.incenter.js"));
        registry.add(require("../uat/src/elements/ua.accordion.js"));
        registry.add(require("../uat/src/elements/ua.address.js"));
        registry.add(require("../uat/src/elements/ua.address.list.js"));
        registry.add(require("../uat/src/elements/ua.address.show.js"));
        registry.add(require("../uat/src/elements/ua.agreement.js"));
        registry.add(require("../uat/src/elements/ua.alert.js"));
        registry.add(require("../uat/src/elements/ua.appbar.js"));
        registry.add(require("../uat/src/elements/ua.attr.data.goto.js"));
        registry.add(require("../uat/src/elements/ua.breadcrumb.js"));
        registry.add(require("../uat/src/elements/ua.card.simple.js"));
        registry.add(require("../uat/src/elements/ua.carousel.js"));
        registry.add(require("../uat/src/elements/ua.checkbox.js"));
        registry.add(require("../uat/src/elements/ua.code.js"));
        registry.add(require("../uat/src/elements/ua.dashboard.item.js"));
        registry.add(require("../uat/src/elements/ua.dashboard.list.js"));
        registry.add(require("../uat/src/elements/ua.devmode.js"));
        registry.add(require("../uat/src/elements/ua.dialog.getdirections.js"));
        registry.add(require("../uat/src/elements/ua.dialog.js"));
        registry.add(require("../uat/src/elements/ua.doc.simple.js"));
        registry.add(require("../uat/src/elements/ua.element.error.js"));
        registry.add(require("../uat/src/elements/ua.element.placeholder.js"));
        registry.add(require("../uat/src/elements/ua.element.scripts.js"));
        registry.add(require("../uat/src/elements/ua.element.serverNotSupported.js"));
        registry.add(require("../uat/src/elements/ua.element.validation.error.js"));
        registry.add(require("../uat/src/elements/ua.footnote.js"));
        registry.add(require("../uat/src/elements/ua.footnotes.js"));
        registry.add(require("../uat/src/elements/ua.fs.center.js"));
        registry.add(require("../uat/src/elements/ua.fs.col.js"));
        registry.add(require("../uat/src/elements/ua.fs.image.js"));
        registry.add(require("../uat/src/elements/ua.fs.module.js"));
        registry.add(require("../uat/src/elements/ua.fs.scrollup.js"));
        registry.add(require("../uat/src/elements/ua.fs.sidebyside.image.js"));
        registry.add(require("../uat/src/elements/ua.fs.sidebyside.sticky.js"));
        registry.add(require("../uat/src/elements/ua.fs.simple.js"));
        registry.add(require("../uat/src/elements/ua.fs.video.js"));
        registry.add(require("../uat/src/elements/ua.getdirections.js"));
        registry.add(require("../uat/src/elements/ua.hcard.simple.js"));
        registry.add(require("../uat/src/elements/ua.header.js"));
        registry.add(require("../uat/src/elements/ua.input.js"));
        registry.add(require("../uat/src/elements/ua.list.item.js"));
        registry.add(require("../uat/src/elements/ua.list.js"));
        registry.add(require("../uat/src/elements/ua.magic.glow.js"));
        registry.add(require("../uat/src/elements/ua.marquee.js"));
        registry.add(require("../uat/src/elements/ua.nav.js"));
        registry.add(require("../uat/src/elements/ua.navbar.item.js"));
        registry.add(require("../uat/src/elements/ua.navbar.js"));
        registry.add(require("../uat/src/elements/ua.navbar.menu.js"));
        registry.add(require("../uat/src/elements/ua.none.js"));
        registry.add(require("../uat/src/elements/ua.notification.icon.js"));
        registry.add(require("../uat/src/elements/ua.phone.js"));
        registry.add(require("../uat/src/elements/ua.platform.video.js"));
        registry.add(require("../uat/src/elements/ua.quick.bio.js"));
        registry.add(require("../uat/src/elements/ua.random.js"));
        registry.add(require("../uat/src/elements/ua.repeater.js"));
        registry.add(require("../uat/src/elements/ua.schema.editor.js"));
        registry.add(require("../uat/src/elements/ua.scroll.totop.js"));
        registry.add(require("../uat/src/elements/ua.select.accordion.js"));
        registry.add(require("../uat/src/elements/ua.select.color.js"));
        registry.add(require("../uat/src/elements/ua.select.datalist.js"));
        registry.add(require("../uat/src/elements/ua.select.date.js"));
        registry.add(require("../uat/src/elements/ua.select.dropdown.js"));
        registry.add(require("../uat/src/elements/ua.select.group.js"));
        registry.add(require("../uat/src/elements/ua.source.js"));
        registry.add(require("../uat/src/elements/ua.switch.js"));
        registry.add(require("../uat/src/elements/ua.t.js"));
        registry.add(require("../uat/src/elements/ua.tabs.js"));
        registry.add(require("../uat/src/elements/ua.tags.js"));
        registry.add(require("../uat/src/elements/ua.text.bygroup.js"));
        registry.add(require("../uat/src/elements/ua.ts.js"));
        registry.add(require("../uat/src/elements/ua.updater.js"));
        registry.add(require("../uat/src/elements/ua.wizard.js"));
        registry.add(require("../plugins/docs/elements/docs.markdown.block.js"));
        registry.add(require("../plugins/docs/elements/docs.markdown.control.js"));
        registry.add(require("../plugins/docs/elements/docs.markdown.page.js"));
    module.exports = registry;
    